import 'isomorphic-fetch'

import { eventsBulkFlagBulkEndpoint } from '~apiConfig'
import { getApiResponseInJSON, getIdToken } from '~utils'
import {
  FILTER_EVENTS_BY_VENUE_ID,
  UPDATE_EVENTS_BY_VENUE_ID
} from '../actionTypes'

export const filterEventsByVenueId = params => async dispatch => {
  const { method, url } = eventsBulkFlagBulkEndpoint.filter
  const idToken = getIdToken()
  const apiResponse = await fetch(url, {
    body: JSON.stringify(params),
    headers: {
      Authorization: `Bearer ${idToken}`
    },
    method
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => console.error(error))
  dispatch({
    type: FILTER_EVENTS_BY_VENUE_ID,
    payload: {
      ...apiResponse
    }
  })
}

export const updateEventStatusByVenueId = (venueId, events, accessToken) => async dispatch => {
  try {
    const { method, url } = eventsBulkFlagBulkEndpoint.update(venueId)
    const idToken = getIdToken()
    await fetch(url, {
      body: JSON.stringify(events),
      headers: {
        Authorization: `Bearer ${idToken}`,
        AccessToken: accessToken
      },
      method
    })
      .then(async response => await getApiResponseInJSON(response))
      .then(response => {
        const { message, success } = response

        dispatch({
          type: UPDATE_EVENTS_BY_VENUE_ID,
          payload: { message, success }
        })
      })
      .catch((error) => {
        console.log(error)
      })
  } catch (error) {
    console.log(error)
  }
}
